module.exports = __webpack_public_path__ + "static/media/payment.aa63182f.png";